export default __webpack_public_path__ + "static/media/4.cd5570a5.svg";